const SignInSSOError = () => import('@/components/SignIn/SignInSSOError')

export default [
	{
		component: SignInSSOError,
		name: 'sso-error',
		path: 'sso-error/:vendor'
	}
]